import R from "ramda";

export const stateForSetDocuments = (state, action) => {
  const totalSumFiltered = action.data.totalSumFiltered;
  const newPagination = R.merge(state.pagination, {
    totalCount: action.data.totalCount,
    totalCountFiltered: action.data.totalCountFiltered,
    totalSumFiltered: totalSumFiltered ? totalSumFiltered.amount.toFixed(2) : "0.00",
    pageNumber: action.data.resetPageNumber ? 1 : state.pagination.pageNumber
  });
  return R.merge(state, {
    filtersCount: action.data.filtersCount,
    isBatchEditMode: false,
    isLoading: false,
    documents: R.path(["data", "documents"], action),
    pagination: newPagination,
    selectedDocumentIds: []
  });
};

export const stateForSetPaginationLimit = (state, limit) => {
  const stateWithLimit = R.set(R.lensPath(["pagination", "limit"]), limit, state);
  return R.set(R.lensPath(["pagination", "pageNumber"]), 1, stateWithLimit);
};

export const stateForNextPage = (state) => {
  const { pagination } = state;
  const currentPage = pagination.pageNumber;
  const maxPage = Math.ceil(pagination.totalCountFiltered / pagination.limit);

  if (currentPage >= maxPage) {
    return state;
  }
  return R.set(R.lensPath(["pagination", "pageNumber"]), currentPage + 1, state);
};

export const stateForPreviousPage = (state) => {
  const currentPage = state.pagination.pageNumber;
  if (currentPage <= 1) {
    return state;
  }
  return R.set(R.lensPath(["pagination", "pageNumber"]), currentPage - 1, state);
};

export const stateForSelectDocuments = (state, documentIds) => {
  const newDocumentIds = typeof documentIds === "string" ? [documentIds] : documentIds;
  const currentIds = state.selectedDocumentIds;
  const newIds = newDocumentIds.filter(id => !currentIds.includes(id));
  const appendedIds = R.append(newIds, currentIds);
  return R.merge(state, { selectedDocumentIds: R.flatten(appendedIds) });
};

export const stateForDeselectDocuments = (state, documentIds) => {
  const currentIds = state.selectedDocumentIds;
  const newIds = currentIds.filter(id => !documentIds.includes(id));
  return R.merge(state, { selectedDocumentIds: newIds });
};

export const updateDocumentState = (state, action) => {
  const updatedDocumentIndex = R.findIndex(R.propEq("id", action.data.document.id))(state.documents);
  const lens = R.lensIndex(updatedDocumentIndex);
  const oldDocument = R.findIndex(lens, state.documents);
  const updatedDocument = R.merge(oldDocument, action.data.document);
  const newDocuments = R.set(lens, updatedDocument, state.documents);
  return R.merge(state, { documents: newDocuments });
};

export const stateForSelectMergeField = (state, action) => {
  const data = (str) => {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  };

  const mergeObject = {
    id: action.data.id,
    data: data(action.data.data)
  };
  return R.set(R.lensPath(["mergeDocument", action.data.field]), mergeObject, state);
};

export const stateForSelectMergeDocument = (state, action) => (
  R.merge(state, {
    selectedMergeDocumentId: action.data.id,
    mergeDocument: null
  })
);

export const stateForShareUrlGenerated = (state, shareUrl) => (
  R.merge(state, { generatedShareUrl: shareUrl })
);

export const stateForVisibleColumns = (state, columnKeys) => {
  const newColumns = state.columns.map(col => {
    if (columnKeys.includes(col.key)) {
      return R.set(R.lensProp("visible"), true, col);
    }
    return R.set(R.lensProp("visible"), false, col);
  });

  return R.merge(state, { columns: newColumns });
};

export const stateForToggleColumn = (state, key) => {
  const index = R.findIndex(R.propEq("key", key))(state.columns);
  const column = state.columns[index];
  const newColumn = R.set(R.lensProp("visible"), !column.visible, column);
  const newColumns = R.set(R.lensIndex(index), newColumn, state.columns);

  return R.merge(state, { columns: newColumns });
};



// WEBPACK FOOTER //
// ./src/js/reducers/functions/document-functions.js